export const toggleAllInputsInContainer = (container, enable) => {
    [...container.querySelectorAll('input, textarea, select')]
        .filter((el) => !el.dataset.togglingDisabled)
        .forEach((el) => {
            el.disabled = !enable;
        });
};
